import {ref, computed} from "vue"
import {defineStore, acceptHMRUpdate, storeToRefs} from "pinia"
import {firestore} from "@/firebase/index.js"
import {collection} from "firebase/firestore"
import {useAppStore} from "./app.js"

export const useOrgSpacesEnvironmentsStore = defineStore("environments", () => {
  const appStore = useAppStore()

  // state
  const environments = ref([])
  const status = ref("init")
  const unsubscribe = ref(null)

  // getters
  const orgEnvironmentsLoaded = computed(() => status.value == "loaded")

  // actions
  async function bind() {
    const {app} = storeToRefs(appStore)
    const {orgId, spaceId} = app.value

    if (!orgId || !spaceId) {
      return
    }

    const ref = collection(firestore, `orgs/${orgId}/spaces/${spaceId}/environments`)
    await this.attach("environments", ref)
  }

  async function unbind() {
    return await this.detach()
  }

  return {
    // state
    environments,
    status,
    unsubscribe,

    // getters
    orgEnvironmentsLoaded,

    // actions
    bind,
    unbind,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useOrgSpacesEnvironmentsStore, import.meta.hot))
}
